export const COMPANY_NAME = "FutureCraft LLC";

export const LINKS = {
	Home: {
		label: "Home",
		href: "/",
		"aria-label": "Go to homepage",
	},
	Pools: {
		label: "Explore Pools",
		href: "/pools",
		"aria-label": "Explore liquidity pools",
	},
	Favorites: {
		label: "Favorites",
		href: "/favorites",
		"aria-label": "View favorite pools",
	},
	Plans: {
		label: "Plans & Pricing",
		href: "/plans",
		"aria-label": "View plans & pricing",
	},
	Login: {
		label: "Log In",
		href: "/login",
		"aria-label": "Log in to your account",
	},
	ForgotPassword: {
		label: "Forgot Password",
		href: "/forgot-password",
		"aria-label": "Reset your password",
	},
};

export const NAVBAR_LINKS_GROUPS = [
	{
		links: [LINKS.Pools, LINKS.Favorites],
	},
	{
		links: [LINKS.Plans, LINKS.Login, LINKS.Plans, LINKS.ForgotPassword],
	},
];
